export const HOME_URL = "/";

/**Order URLS */
export const ORDERS_URL = "/orders"
export const GROUPS_MANAGEMENT_URL = "/groups"
export const ORDERS_HISTORY_URL = `${ORDERS_URL}/history`;
export const NEW_ORDERS_URL = `${ORDERS_URL}/new`;
export const OPEN_ORDERS_URL = `${ORDERS_URL}/open`;

export const ANALYTICS_DASHBOARD_URL = "/dashboard";

export const ERROR_URL = "/error";

export const PAYMENTS_URL = "/payments";

export const REGISTER_URL = "/register";
export const SELF_SIGNUP_URL = '/sign-up';
export const SQUARE_SIGNUP_URL = "/signup/square";
export const EMAIL_VERIFICATION_URL = "/signup/email-verification";
export const VENUE_IMPORTER_URL = "/signup/square/venue-importer";
export const SQUARE_LOCATION_URL = "/signup/square/venue-importer/square-locations";
export const SQUARE_SYNC = "/square";
export const SQUARE_OAUTH_REDIRECT = "/square/oauth/redirect";
export const REVIEWS_URL = `/reviews`;

/**Profile urls */
export const PROFILE_URL = "/profile";
export const PROFILE_SUBCATEGORIES_URL = `${PROFILE_URL}/subcategories`;
export const PROFILE_EXTRAS_URL = `${PROFILE_URL}/extras`;
export const PROFILE_PREFERENCES_URL = `${PROFILE_URL}/preferences`;
export const PROFILE_SETTINGS_URL = `${PROFILE_URL}/settings`;
export const PROFILE_PAYMENTS_URL = `${PROFILE_URL}/payments`;
export const PROFILE_REPORTS_URL = `${PROFILE_URL}/reports`;
export const PROFILE_TRADING_TIMES_URL = `${PROFILE_URL}/trading-times`;
export const PROFILE_DETAILS_URL = `${PROFILE_URL}/details`;
export const PROFILE_VENUE_URL = `${PROFILE_URL}/venue-url`;
export const PROFILE_DOWNLOAD_QR_CODE = `${PROFILE_URL}/qr-code`;
export const PROFILE_VENUE_IMAGES = `${PROFILE_URL}/venue-images`;
export const PROFILE_EPOS_NOW = `${PROFILE_URL}/epos-now`;
export const PROFILE_MENU_SYNC = `${PROFILE_URL}/menu-sync`;
export const PROFILE_TABLE_RANGES = `${PROFILE_URL}/venue-areas`;
export const PROFILE_EXTERNAL_LINKS = `${PROFILE_URL}/links`;
export const PROFILE_ORDER_SETTINGS_URL = `${PROFILE_URL}/order-settings`;
export const PROFILE_ITEMS_URL = `${PROFILE_URL}/items`;
export const CUSTOMERS = `${PROFILE_URL}/customer-details`;
export const PROFILE_QR_CODE = `${PROFILE_URL}/qr-code`;
export const OPEN_BANKING_URL = `${PROFILE_PAYMENTS_URL}/open-banking`;
export const PROFILE_PRINTER_SETTINGS = `${PROFILE_URL}/printer-settings`;

/**Product URLS */
export const PRODUCTS_URL = "/products";
export const PRODUCTS_ITEMS_URL = `${PRODUCTS_URL}/items`;
export const PRODUCTS_SUBCATEGORIES = `${PRODUCTS_URL}/subcategories`;
export const PRODUCTS_EXTRAS = `${PRODUCTS_URL}/extras`;
export const PRODUCTS_PREFERENCE = `${PRODUCTS_URL}/preferences`;
export const PRODUCTS_MANAGE_MENU_URL = `${PRODUCTS_URL}/manage-menu`;

export const TAXES_URL = "/taxes";

export const DISCOUNTS_URL = "/discounts";

export const RESET_PASSWORD_URL = "/reset-password";
export const SET_PASSWORD_URL = "/set-password";
export const FORGOT_PASSWORD_URL = "/forgot-password";
export const EMAIL_VERIFYING_URL = "/verify";

export const NEW_MERCHANT = '/welcome';
export const VENUES_OVERVIEW = "/venues-overview";

export const SUBSCRIPTION_URL = "/subscription";

/** User Managemnt */
export const USER_MANAGEMENT = "/user-management";

export const CREATE_USER_MERCHANT = "/create-account";

export const NO_VENUES = "/no-venues";

export const NO_PERMISSIONS = "/not-authorised";

export const VENUES = "/venue";